import { useContext, useEffect, useState } from "react";
import { ContractDto } from "../../../../dtos/catalogs/contract/ContractDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import ContractDetailSkeleton from "./ContractDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import ContractDetailMain from "./ContractDetailMain";

interface IProps {
  model: ContractDto | null;
  modelUpdatedEvent: (newModel: ContractDto) => void;
}

interface ContractModel {
  id: string;
  name: string;
  vendorCustomerId?: string;
}

export const ContractDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ContractModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("vendorCustomerId", model.vendorCustomerId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: ContractModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: ContractDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <ContractDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <ContractDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
